export default __webpack_public_path__ + "static/media/contactbgimage.6bef9083.png";